const baseTranslations = {
  en: {
    // Header & Navigation
    appName: 'Petso',
    findParks: 'Find Parks',
    myProfile: 'My Profile',
    settings: 'Settings',

    // View Toggle
    mapView: 'Map',
    listView: 'List',

    // Search & Filter
    searchParks: 'Search parks...',
    filters: 'Filters',
    clearFilters: 'Clear All',
    applyFilters: 'Apply Filters',

    // Filter Categories
    accessRules: 'Access Rules',
    offLeash: 'Off-leash Allowed',
    onLeash: 'On-leash Only',
    mixedZones: 'Mixed Zones',

    safetyLayout: 'Safety & Layout',
    fullyFenced: 'Fully Fenced',
    partiallyFenced: 'Partially Fenced',
    noFencing: 'No Fencing',
    separateAreas: 'Separate Small/Large Areas',

    amenities: 'Amenities',
    waterFountain: 'Water Fountain',
    wasteBags: 'Waste Bag Dispensers',
    benches: 'Benches',
    shade: 'Shade',
    parking: 'Parking',
    agilityEquipment: 'Agility Equipment',

    environment: 'Environment',
    grass: 'Grass',
    dirt: 'Dirt',
    artificialTurf: 'Artificial Turf',
    flatTerrain: 'Flat Terrain',
    hillyTerrain: 'Hilly Terrain',
    quiet: 'Quiet',
    crowded: 'Crowded',

    // Pet Selection
    selectPet: 'Select Pet',
    noPets: 'No pets added yet',
    addPet: 'Add Pet',

    // Park Details
    distance: 'Distance',
    rating: 'Rating',
    reviews: 'Reviews',
    openNow: 'Open Now',
    closed: 'Closed',
    hours: 'Hours',
    address: 'Address',
    directions: 'Get Directions',

    rulesRegulations: 'Rules & Regulations',
    safetyInfo: 'Safety Information',
    knownHazards: 'Known Hazards',
    recentAlerts: 'Recent Alerts',

    // Reviews
    writeReview: 'Write a Review',
    sortBy: 'Sort by',
    newest: 'Newest',
    mostHelpful: 'Most Helpful',
    highestRated: 'Highest Rated',
    lowestRated: 'Lowest Rated',

    uploadPhotos: 'Upload Photos',
    submitReview: 'Submit Review',
    helpful: 'Helpful',
    report: 'Report',

    // Community
    nearbyUsers: 'Nearby Pet Owners',
    organizeMeetup: 'Organize Meetup',
    findWalkingBuddy: 'Find Walking Buddy',

    // Offline
    offlineMode: 'Offline Mode',
    downloadMap: 'Download for Offline',
    downloaded: 'Downloaded',

    // Stats
    totalParks: 'Total Parks',
    avgRating: 'Avg Rating',
    nearby: 'Nearby',
    parkFound: 'park found',
    parksFound: 'parks found',
    parksCount: 'parks',

    // Google Maps
    googleMapsNotConfigured: 'Google Maps not configured',
    googleMapsNotConfiguredDescription:
      'Set PUBLIC_GOOGLE_MAPS_API_KEY in petso/.env to enable the map.',
    failedToLoadGoogleMaps: 'Failed to load Google Maps',
    failedToLoadGoogleMapsDescription:
      'Check your API key and that the Maps JavaScript API + Places API are enabled.',
    loadingMap: 'Loading map…',

    // Walking Buddy
    walkingBuddy: 'Walking Buddy',
    findCompatiblePartners: 'Find compatible walking partners',
    editWalkingBuddyPreferences: 'Edit Walking Buddy Preferences',
    walkingBuddySetup: 'Walking Buddy Setup',
    updateAvailabilityPreferredTime:
      'Update your availability and preferred time',
    findCompatiblePartnersInArea:
      'Find compatible walking partners in your area',
    whenAvailable: 'When are you usually available?',
    preferredTimeOfDay: 'Preferred time of day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    flexible: 'Flexible',
    privacy: 'Privacy',
    privacyNoticeWalkingBuddy:
      'Only users who also have Walking Buddy enabled can see your profile. You can deactivate anytime.',
    savePreferences: 'Save Preferences',
    activateFindMatches: 'Activate & Find Matches',
    saving: 'Saving…',
    noMatchesYet: 'No matches yet',
    checkBackLaterForMatches:
      'Check back later for compatible walking partners',
    matchLabel: 'Match',
    kmAway: 'km away',
    parkInCommon: 'park in common',
    parksInCommon: 'parks in common',
    chat: 'Chat',
    editPreferences: 'Edit Preferences',
    energy: 'Energy',
    close: 'Close',
    walkingBuddyActive: 'Walking Buddy is active',
    walkingBuddyDeactivated: 'Walking Buddy deactivated',
    failedToActivateWalkingBuddy: 'Failed to activate Walking Buddy',
    failedToLoadMatches: 'Failed to load matches',
    failedToSaveChanges: 'Failed to save changes',

    // Empty States
    noParksNearby: 'No parks found nearby',
    tryAdjustingFilters: 'Try adjusting your filters or search area',
    noReviews: 'No reviews yet',
    beFirst: 'Be the first to review this park!',

    // Actions
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    share: 'Share',
    favorite: 'Favorite',

    // Pet Attributes
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    lowEnergy: 'Low Energy',
    mediumEnergy: 'Medium Energy',
    highEnergy: 'High Energy',
    shy: 'Shy',
    social: 'Social',
    reactive: 'Reactive',
    puppy: 'Puppy',
    senior: 'Senior',
    anxious: 'Anxious',
    surface: 'Surface',
    terrain: 'Terrain',
    crowdLevel: 'Crowd Level',
    about: 'About',
    overview: 'Overview',
    meetups: 'Meetups',
    organize: 'Organize',
    upcomingMeetups: 'Upcoming Meetups',
    noUpcomingMeetups: 'No upcoming meetups',
    beFirstOrganizeMeetup: 'Be the first to organize a meetup at this park!',
    createMeetup: 'Create Meetup',
    writeFirstReview: 'Write First Review',
    verifiedBadge: 'Verified',
    addPhotos: 'Add Photos',
    shareToSocial: 'Share to Social',
    helpfulMarked: 'Marked as helpful',
    voteRemoved: 'Vote removed',
    failedToUpdateVote: 'Failed to update vote',
    linkCopiedToClipboard: 'Link copied to clipboard!',
    shareParkText: 'Check out {{parkName}} on Petso!',
    filterParksDescription: 'Filter parks by various criteria',
    parkDetails: 'Park Details',
    parkDetailsDescription: 'Detailed information about the selected park',
    yourLocation: 'Your location',
    centerOnCurrentLocation: 'Center on current location',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    openingSocialToChat: 'Opening Social to chat...',
    failedToStartChat: 'Failed to start chat',
    meetupFull: 'This meetup is full',
    rsvpGoing: "You're going!",
    rsvpMaybe: 'Marked as maybe',
    rsvpCancelled: 'RSVP cancelled',
    failedToUpdateRSVP: 'Failed to update RSVP',
    going: 'going',
    spotLeftSingular: 'spot left',
    spotsLeftPlural: 'spots left',
    full: 'Full',
    organizedBy: 'Organized by',
    cancelRSVP: 'Cancel RSVP',
    imGoing: "I'm Going",
    maybe: 'Maybe',
    minutesShort: 'min',
    dateRequired: 'Date *',
    timeRequired: 'Time *',
    meetupEnterTitle: 'Please enter a title',
    meetupSelectDateTime: 'Please select date and time',
    meetupTimeFuture: 'Meetup time must be in the future',
    meetupDurationRange: 'Duration must be between 30 and 480 minutes',
    meetupParticipantsRange: 'Participants must be between 2 and 50',
    meetupCreatedSuccess: 'Meetup created successfully!',
    meetupCreateFailed: 'Failed to create meetup. Please try again.',
    createMeetupAtPark:
      'Create a meetup at {{parkName}} and connect with other pet owners',
    meetupTitleRequired: 'Meetup Title *',
    meetupTitlePlaceholder: 'e.g., Morning Walk & Play',
    description: 'Description',
    meetupDescriptionPlaceholder: 'Share details about the meetup...',
    meetupDurationMinutes: 'Duration (minutes)',
    meetupDurationHint: '30-480 minutes',
    meetupMaxParticipants: 'Max Participants',
    meetupParticipantsHint: '2-50 people',
    meetupOrganizerTipsTitle: 'Organizer tips:',
    meetupOrganizerTipsBody:
      'Meet in a visible location, share contact info with participants, and ensure all dogs are properly leashed or in designated off-leash areas.',
    creating: 'Creating...',
    ratingRequired: 'Rating *',
    reviewSelectRating: 'Please select a rating',
    reviewMinCharacters: 'Review must be at least {{count}} characters',
    reviewMaxCharacters: 'Review must be less than {{count}} characters',
    reviewSubmittedSuccess: 'Review submitted successfully!',
    reviewSubmitFailed: 'Failed to submit review. Please try again.',
    shareExperienceAtPark: 'Share your experience at {{parkName}}',
    starSingular: 'star',
    starPlural: 'stars',
    titleOptional: 'Title (optional)',
    reviewTitlePlaceholder: 'e.g., Great park for small dogs!',
    yourReviewRequired: 'Your Review *',
    reviewContentPlaceholder: 'Share details about your experience...',
    reviewMinimumCharacters: 'Minimum {{count}} characters',
    visitDateOptional: 'Visit Date (optional)',
    tagsOptional: 'Tags (optional)',
    reviewingWith: 'Reviewing with:',
    submitting: 'Submitting...',
    reviewTagClean: 'Clean',
    reviewTagSafe: 'Safe',
    reviewTagBusy: 'Busy',
    reviewTagQuiet: 'Quiet',
    reviewTagShady: 'Shady',
    reviewTagWellMaintained: 'Well Maintained',
    reviewTagSpacious: 'Spacious',
    reviewTagFriendlyDogs: 'Friendly Dogs',
    photoInvalidType: 'Invalid file type. Use JPG, PNG, or WebP.',
    photoTooLarge: 'File too large. Maximum size is 5MB.',
    photoMaxAllowed: 'Maximum {{count}} photos allowed.',
    photoSelectAtLeastOne: 'Please select at least one photo',
    photoUploadedPendingModeration:
      '{{count}} photo{{suffix}} uploaded! Pending moderation.',
    photoUploadFailed: 'Failed to upload photos. Please try again.',
    photosUploaded: 'Photos uploaded',
    photosUploadedDescription:
      'Your photos from {{parkName}} are uploaded and pending moderation. Share to Petso Social?',
    photosUploadDescription:
      'Share photos of {{parkName}}. Photos will be reviewed before appearing in the gallery.',
    alsoShareToSocial: 'Also share to Social?',
    alsoShareToSocialDescription:
      'Post to Petso Social with location set to {{parkName}}. You can add a caption and tag pets.',
    done: 'Done',
    photoDropOrBrowse: 'Drop photos here or click to browse',
    photoFormatsHint: 'JPG, PNG, or WebP • Max 5MB • Up to {{count}} photos',
    photosCount: 'Photos ({{current}}/{{max}})',
    maximumReached: 'Maximum reached',
    photoPreviewAlt: 'Preview',
    photoCaptionOptional: 'Add a caption (optional)',
    moderationNotice: 'Moderation Notice',
    moderationNoticeDescription:
      'Photos will be reviewed before appearing publicly. This helps maintain quality and keep our community safe.',
    uploading: 'Uploading...',
    uploadAction: 'Upload{{count}}',
    reportSubmittedSuccess:
      'Report submitted. Thank you for keeping our community safe.',
    reportSubmitFailed: 'Failed to submit report. Please try again.',
    reportTypeReview: 'review',
    reportTypePhoto: 'photo',
    reportTypeMessage: 'message',
    reportContentLabel: 'Report {{type}}',
    reportContentDescription:
      'Help us keep Petso safe by reporting inappropriate content',
    reporting: 'Reporting:',
    reasonForReportingRequired: 'Reason for reporting *',
    reportReasonSpam: 'Spam or advertising',
    reportReasonInappropriate: 'Inappropriate content',
    reportReasonHarassment: 'Harassment or bullying',
    reportReasonMisinformation: 'False or misleading information',
    reportReasonOffensive: 'Offensive language or imagery',
    reportReasonOther: 'Other (please specify)',
    additionalDetails: 'Additional details',
    optional: 'optional',
    reportContextPlaceholder: 'Please provide more context...',
    reportPrivacyNotice:
      'Reports are reviewed by our moderation team. Your report is anonymous to the content creator.',
    submitReport: 'Submit Report',
    weatherCurrent: 'Current Weather',
    weatherUpdated: 'Updated',
    humidity: 'Humidity',
    wind: 'Wind',
    weatherExcellent: '🌟 Excellent for walking',
    weatherGood: '👍 Good for walking',
    weatherFair: '😐 Fair conditions',
    weatherPoor: '⚠️ Poor conditions',
    weatherUnknown: 'Unknown',
  },
  es: {
    // Header & Navigation
    appName: 'Petso',
    findParks: 'Buscar Parques',
    myProfile: 'Mi Perfil',
    settings: 'Configuración',

    // View Toggle
    mapView: 'Mapa',
    listView: 'Lista',

    // Search & Filter
    searchParks: 'Buscar parques...',
    filters: 'Filtros',
    clearFilters: 'Limpiar Todo',
    applyFilters: 'Aplicar Filtros',

    // Filter Categories
    accessRules: 'Reglas de Acceso',
    offLeash: 'Sin Correa Permitido',
    onLeash: 'Solo con Correa',
    mixedZones: 'Zonas Mixtas',

    safetyLayout: 'Seguridad y Diseño',
    fullyFenced: 'Totalmente Cercado',
    partiallyFenced: 'Parcialmente Cercado',
    noFencing: 'Sin Cercas',
    separateAreas: 'Áreas Separadas Pequeñas/Grandes',

    amenities: 'Servicios',
    waterFountain: 'Fuente de Agua',
    wasteBags: 'Dispensadores de Bolsas',
    benches: 'Bancas',
    shade: 'Sombra',
    parking: 'Estacionamiento',
    agilityEquipment: 'Equipo de Agilidad',

    environment: 'Ambiente',
    grass: 'Césped',
    dirt: 'Tierra',
    artificialTurf: 'Césped Artificial',
    flatTerrain: 'Terreno Plano',
    hillyTerrain: 'Terreno Montañoso',
    quiet: 'Tranquilo',
    crowded: 'Concurrido',

    // Pet Selection
    selectPet: 'Seleccionar Mascota',
    noPets: 'No hay mascotas agregadas',
    addPet: 'Agregar Mascota',

    // Park Details
    distance: 'Distancia',
    rating: 'Calificación',
    reviews: 'Reseñas',
    openNow: 'Abierto Ahora',
    closed: 'Cerrado',
    hours: 'Horario',
    address: 'Dirección',
    directions: 'Cómo Llegar',

    rulesRegulations: 'Reglas y Regulaciones',
    safetyInfo: 'Información de Seguridad',
    knownHazards: 'Peligros Conocidos',
    recentAlerts: 'Alertas Recientes',

    // Reviews
    writeReview: 'Escribir Reseña',
    sortBy: 'Ordenar por',
    newest: 'Más Reciente',
    mostHelpful: 'Más Útil',
    highestRated: 'Mejor Calificado',
    lowestRated: 'Peor Calificado',

    uploadPhotos: 'Subir Fotos',
    submitReview: 'Enviar Reseña',
    helpful: 'Útil',
    report: 'Reportar',

    // Community
    nearbyUsers: 'Dueños de Mascotas Cercanos',
    organizeMeetup: 'Organizar Reunión',
    findWalkingBuddy: 'Encontrar Compañero de Paseo',

    // Offline
    offlineMode: 'Modo Sin Conexión',
    downloadMap: 'Descargar para Modo Sin Conexión',
    downloaded: 'Descargado',

    // Stats
    totalParks: 'Parques totales',
    avgRating: 'Valoración media',
    nearby: 'Cercanos',
    parkFound: 'parque encontrado',
    parksFound: 'parques encontrados',
    parksCount: 'parques',

    // Google Maps
    googleMapsNotConfigured: 'Google Maps no configurado',
    googleMapsNotConfiguredDescription:
      'Configura PUBLIC_GOOGLE_MAPS_API_KEY en petso/.env para activar el mapa.',
    failedToLoadGoogleMaps: 'Error al cargar Google Maps',
    failedToLoadGoogleMapsDescription:
      'Comprueba tu clave API y que la API de Maps JavaScript y Places estén activadas.',
    loadingMap: 'Cargando mapa…',

    // Walking Buddy
    walkingBuddy: 'Compañero de paseo',
    findCompatiblePartners: 'Encuentra compañeros de paseo compatibles',
    editWalkingBuddyPreferences: 'Editar preferencias de compañero de paseo',
    walkingBuddySetup: 'Configuración de compañero de paseo',
    updateAvailabilityPreferredTime:
      'Actualiza tu disponibilidad y horario preferido',
    findCompatiblePartnersInArea:
      'Encuentra compañeros de paseo compatibles en tu zona',
    whenAvailable: '¿Cuándo sueles estar disponible?',
    preferredTimeOfDay: 'Momento del día preferido',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    morning: 'Mañana',
    afternoon: 'Tarde',
    evening: 'Noche',
    flexible: 'Flexible',
    privacy: 'Privacidad',
    privacyNoticeWalkingBuddy:
      'Solo los usuarios que también tengan activado Compañero de paseo pueden ver tu perfil. Puedes desactivarlo cuando quieras.',
    savePreferences: 'Guardar preferencias',
    activateFindMatches: 'Activar y buscar coincidencias',
    saving: 'Guardando…',
    noMatchesYet: 'Aún no hay coincidencias',
    checkBackLaterForMatches:
      'Vuelve más tarde para encontrar compañeros de paseo compatibles',
    matchLabel: 'Coincidencia',
    kmAway: 'km de distancia',
    parkInCommon: 'parque en común',
    parksInCommon: 'parques en común',
    chat: 'Chat',
    editPreferences: 'Editar preferencias',
    energy: 'Energía',
    close: 'Cerrar',
    walkingBuddyActive: 'Compañero de paseo activado',
    walkingBuddyDeactivated: 'Compañero de paseo desactivado',
    failedToActivateWalkingBuddy: 'Error al activar Compañero de paseo',
    failedToLoadMatches: 'Error al cargar coincidencias',
    failedToSaveChanges: 'Error al guardar los cambios',

    // Empty States
    noParksNearby: 'No se encontraron parques cercanos',
    tryAdjustingFilters: 'Intenta ajustar tus filtros o área de búsqueda',
    noReviews: 'Sin reseñas aún',
    beFirst: '¡Sé el primero en reseñar este parque!',

    // Actions
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    share: 'Compartir',
    favorite: 'Favorito',

    // Pet Attributes
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    lowEnergy: 'Baja Energía',
    mediumEnergy: 'Energía Media',
    highEnergy: 'Alta Energía',
    shy: 'Tímido',
    social: 'Social',
    reactive: 'Reactivo',
    puppy: 'Cachorro',
    senior: 'Senior',
    anxious: 'Ansioso',
  },
  pl: {
    appName: 'Petso',
    findParks: 'Szukaj parków',
    myProfile: 'Mój profil',
    settings: 'Ustawienia',
    mapView: 'Mapa',
    listView: 'Lista',
    searchParks: 'Szukaj parków...',
    filters: 'Filtry',
    clearFilters: 'Wyczyść wszystko',
    applyFilters: 'Zastosuj filtry',
    accessRules: 'Zasady wstępu',
    offLeash: 'Bez smyczy dozwolone',
    onLeash: 'Tylko na smyczy',
    mixedZones: 'Strefy mieszane',
    safetyLayout: 'Bezpieczeństwo i układ',
    fullyFenced: 'W pełni ogrodzony',
    partiallyFenced: 'Częściowo ogrodzony',
    noFencing: 'Bez ogrodzenia',
    separateAreas: 'Osobne obszary małe/duże',
    amenities: 'Udogodnienia',
    waterFountain: 'Poidło',
    wasteBags: 'Dozowniki worków',
    benches: 'Ławki',
    shade: 'Cień',
    parking: 'Parking',
    agilityEquipment: 'Sprzęt do agility',
    environment: 'Środowisko',
    grass: 'Trawa',
    dirt: 'Ziemia',
    artificialTurf: 'Sztuczna trawa',
    flatTerrain: 'Płaski teren',
    hillyTerrain: 'Pagórkowaty teren',
    quiet: 'Cichy',
    crowded: 'Zatłoczony',
    selectPet: 'Wybierz zwierzaka',
    noPets: 'Brak dodanych zwierząt',
    addPet: 'Dodaj zwierzaka',
    distance: 'Odległość',
    rating: 'Ocena',
    reviews: 'Recenzje',
    openNow: 'Otwarte',
    closed: 'Zamknięte',
    hours: 'Godziny',
    address: 'Adres',
    directions: 'Jak dojechać',
    rulesRegulations: 'Zasady i regulamin',
    safetyInfo: 'Informacje o bezpieczeństwie',
    knownHazards: 'Znane zagrożenia',
    recentAlerts: 'Ostatnie alerty',
    writeReview: 'Napisz recenzję',
    sortBy: 'Sortuj według',
    newest: 'Najnowsze',
    mostHelpful: 'Najbardziej pomocne',
    highestRated: 'Najwyżej oceniane',
    lowestRated: 'Najniżej oceniane',
    uploadPhotos: 'Prześlij zdjęcia',
    submitReview: 'Wyślij recenzję',
    helpful: 'Pomocne',
    report: 'Zgłoś',
    nearbyUsers: 'Właściciele zwierząt w okolicy',
    organizeMeetup: 'Zorganizuj spotkanie',
    findWalkingBuddy: 'Znajdź towarzysza spacerów',
    offlineMode: 'Tryb offline',
    downloadMap: 'Pobierz do użycia offline',
    downloaded: 'Pobrano',
    // Stats
    totalParks: 'Łącznie parków',
    avgRating: 'Śr. ocena',
    nearby: 'W pobliżu',
    parkFound: 'park znaleziony',
    parksFound: 'parków znaleziono',
    parksCount: 'parków',

    // Google Maps
    googleMapsNotConfigured: 'Google Maps nie skonfigurowane',
    googleMapsNotConfiguredDescription:
      'Ustaw PUBLIC_GOOGLE_MAPS_API_KEY w petso/.env, aby włączyć mapę.',
    failedToLoadGoogleMaps: 'Nie udało się załadować Google Maps',
    failedToLoadGoogleMapsDescription:
      'Sprawdź klucz API oraz czy włączono Maps JavaScript API i Places API.',
    loadingMap: 'Ładowanie mapy…',

    // Walking Buddy
    walkingBuddy: 'Towarzysz spacerów',
    findCompatiblePartners: 'Znajdź odpowiednich towarzyszy spacerów',
    editWalkingBuddyPreferences: 'Edytuj preferencje towarzysza spacerów',
    walkingBuddySetup: 'Konfiguracja towarzysza spacerów',
    updateAvailabilityPreferredTime:
      'Zaktualizuj dostępność i preferowany czas',
    findCompatiblePartnersInArea:
      'Znajdź odpowiednich towarzyszy spacerów w swojej okolicy',
    whenAvailable: 'Kiedy zwykle jesteś dostępny?',
    preferredTimeOfDay: 'Preferowana pora dnia',
    monday: 'Poniedziałek',
    tuesday: 'Wtorek',
    wednesday: 'Środa',
    thursday: 'Czwartek',
    friday: 'Piątek',
    saturday: 'Sobota',
    sunday: 'Niedziela',
    morning: 'Rano',
    afternoon: 'Popołudnie',
    evening: 'Wieczór',
    flexible: 'Elastycznie',
    privacy: 'Prywatność',
    privacyNoticeWalkingBuddy:
      'Tylko użytkownicy z włączonym Towarzyszem spacerów widzą Twój profil. Możesz wyłączyć to w dowolnym momencie.',
    savePreferences: 'Zapisz preferencje',
    activateFindMatches: 'Aktywuj i znajdź dopasowania',
    saving: 'Zapisywanie…',
    noMatchesYet: 'Brak dopasowań',
    checkBackLaterForMatches:
      'Sprawdź później, aby znaleźć odpowiednich towarzyszy spacerów',
    matchLabel: 'Dopasowanie',
    kmAway: 'km stąd',
    parkInCommon: 'park wspólny',
    parksInCommon: 'parków wspólnych',
    chat: 'Czat',
    editPreferences: 'Edytuj preferencje',
    energy: 'Energia',
    close: 'Zamknij',
    walkingBuddyActive: 'Towarzysz spacerów jest aktywny',
    walkingBuddyDeactivated: 'Towarzysz spacerów dezaktywowany',
    failedToActivateWalkingBuddy: 'Nie udało się aktywować Towarzysza spacerów',
    failedToLoadMatches: 'Nie udało się załadować dopasowań',
    failedToSaveChanges: 'Nie udało się zapisać zmian',

    noParksNearby: 'Brak parków w okolicy',
    tryAdjustingFilters: 'Spróbuj zmienić filtry lub obszar wyszukiwania',
    noReviews: 'Brak recenzji',
    beFirst: 'Bądź pierwszy, który oceni ten park!',
    save: 'Zapisz',
    cancel: 'Anuluj',
    edit: 'Edytuj',
    delete: 'Usuń',
    share: 'Udostępnij',
    favorite: 'Ulubione',
    small: 'Mały',
    medium: 'Średni',
    large: 'Duży',
    lowEnergy: 'Niska energia',
    mediumEnergy: 'Średnia energia',
    highEnergy: 'Wysoka energia',
    shy: 'Nieśmiały',
    social: 'Towarzyski',
    reactive: 'Reaktywny',
    puppy: 'Szczenię',
    senior: 'Senior',
    anxious: 'Lękliwy',
  },
  nl: {
    appName: 'Petso',
    findParks: 'Parken zoeken',
    myProfile: 'Mijn profiel',
    settings: 'Instellingen',
    mapView: 'Kaart',
    listView: 'Lijst',
    searchParks: 'Zoek parken...',
    filters: 'Filters',
    clearFilters: 'Alles wissen',
    applyFilters: 'Filters toepassen',
    accessRules: 'Toegangsregels',
    offLeash: 'Zonder lijn toegestaan',
    onLeash: 'Alleen aan de lijn',
    mixedZones: 'Gemengde zones',
    safetyLayout: 'Veiligheid & indeling',
    fullyFenced: 'Volledig omheind',
    partiallyFenced: 'Gedeeltelijk omheind',
    noFencing: 'Geen omheining',
    separateAreas: 'Aparte kleine/grote zones',
    amenities: 'Voorzieningen',
    waterFountain: 'Waterfontein',
    wasteBags: 'Afvalzakjes',
    benches: 'Banken',
    shade: 'Schaduw',
    parking: 'Parkeren',
    agilityEquipment: 'Agility-apparatuur',
    environment: 'Omgeving',
    grass: 'Gras',
    dirt: 'Zand',
    artificialTurf: 'Kunstgras',
    flatTerrain: 'Vlak terrein',
    hillyTerrain: 'Heuvelachtig terrein',
    quiet: 'Rustig',
    crowded: 'Druk',
    selectPet: 'Selecteer huisdier',
    noPets: 'Nog geen huisdieren toegevoegd',
    addPet: 'Huisdier toevoegen',
    distance: 'Afstand',
    rating: 'Beoordeling',
    reviews: 'Recensies',
    openNow: 'Nu open',
    closed: 'Gesloten',
    hours: 'Openingstijden',
    address: 'Adres',
    directions: 'Routebeschrijving',
    rulesRegulations: 'Regels en voorschriften',
    safetyInfo: 'Veiligheidsinformatie',
    knownHazards: 'Bekende gevaren',
    recentAlerts: 'Recente meldingen',
    writeReview: 'Recensie schrijven',
    sortBy: 'Sorteren op',
    newest: 'Nieuwste',
    mostHelpful: 'Meest nuttig',
    highestRated: 'Hoogst beoordeeld',
    lowestRated: 'Laagst beoordeeld',
    uploadPhotos: "Foto's uploaden",
    submitReview: 'Recensie verzenden',
    helpful: 'Nuttig',
    report: 'Rapporteren',
    nearbyUsers: 'Huisdiereneigenaren in de buurt',
    organizeMeetup: 'Afspraak organiseren',
    findWalkingBuddy: 'Wandelmaatje vinden',
    offlineMode: 'Offlinemodus',
    downloadMap: 'Downloaden voor offline',
    downloaded: 'Gedownload',
    totalParks: 'Totaal parken',
    avgRating: 'Gem. beoordeling',
    nearby: 'In de buurt',
    parkFound: 'park gevonden',
    parksFound: 'parken gevonden',
    parksCount: 'parken',
    googleMapsNotConfigured: 'Google Maps niet geconfigureerd',
    googleMapsNotConfiguredDescription:
      'Stel PUBLIC_GOOGLE_MAPS_API_KEY in petso/.env in om de kaart te activeren.',
    failedToLoadGoogleMaps: 'Google Maps laden mislukt',
    failedToLoadGoogleMapsDescription:
      'Controleer je API-sleutel en of de Maps JavaScript API en Places API zijn ingeschakeld.',
    loadingMap: 'Kaart laden…',
    walkingBuddy: 'Wandelmaatje',
    findCompatiblePartners: 'Vind geschikte wandelmaatjes',
    editWalkingBuddyPreferences: 'Voorkeuren wandelmaatje bewerken',
    walkingBuddySetup: 'Wandelmaatje instellen',
    updateAvailabilityPreferredTime:
      'Werk je beschikbaarheid en voorkeurstijd bij',
    findCompatiblePartnersInArea:
      'Vind geschikte wandelmaatjes in jouw omgeving',
    whenAvailable: 'Wanneer ben je meestal beschikbaar?',
    preferredTimeOfDay: 'Voorkeurstijd van de dag',
    monday: 'Maandag',
    tuesday: 'Dinsdag',
    wednesday: 'Woensdag',
    thursday: 'Donderdag',
    friday: 'Vrijdag',
    saturday: 'Zaterdag',
    sunday: 'Zondag',
    morning: 'Ochtend',
    afternoon: 'Middag',
    evening: 'Avond',
    flexible: 'Flexibel',
    privacy: 'Privacy',
    privacyNoticeWalkingBuddy:
      'Alleen gebruikers die Wandelmaatje ook hebben ingeschakeld kunnen je profiel zien. Je kunt het altijd uitschakelen.',
    savePreferences: 'Voorkeuren opslaan',
    activateFindMatches: 'Activeren en matchen zoeken',
    saving: 'Opslaan…',
    noMatchesYet: 'Nog geen matches',
    checkBackLaterForMatches: 'Kom later terug voor geschikte wandelmaatjes',
    matchLabel: 'Match',
    kmAway: 'km verderop',
    parkInCommon: 'park gemeen',
    parksInCommon: 'parken gemeen',
    chat: 'Chatten',
    editPreferences: 'Voorkeuren bewerken',
    energy: 'Energie',
    close: 'Sluiten',
    walkingBuddyActive: 'Wandelmaatje is actief',
    walkingBuddyDeactivated: 'Wandelmaatje gedeactiveerd',
    failedToActivateWalkingBuddy: 'Wandelmaatje activeren mislukt',
    failedToLoadMatches: 'Matches laden mislukt',
    failedToSaveChanges: 'Wijzigingen opslaan mislukt',
    noParksNearby: 'Geen parken in de buurt',
    tryAdjustingFilters: 'Pas je filters of zoekgebied aan',
    noReviews: 'Nog geen recensies',
    beFirst: 'Wees de eerste die dit park beoordeelt!',
    save: 'Opslaan',
    cancel: 'Annuleren',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    share: 'Delen',
    favorite: 'Favoriet',
    small: 'Klein',
    medium: 'Middel',
    large: 'Groot',
    lowEnergy: 'Rustig',
    mediumEnergy: 'Gemiddelde energie',
    highEnergy: 'Energiek',
    shy: 'Verlegen',
    social: 'Sociaal',
    reactive: 'Reactief',
    puppy: 'Puppy',
    senior: 'Senior',
    anxious: 'Angstig',
  },
  fr: {
    appName: 'Petso',
    findParks: 'Trouver des parcs',
    myProfile: 'Mon profil',
    settings: 'Paramètres',
    mapView: 'Carte',
    listView: 'Liste',
    searchParks: 'Rechercher des parcs...',
    filters: 'Filtres',
    clearFilters: 'Tout effacer',
    applyFilters: 'Appliquer les filtres',
    accessRules: "Règles d'accès",
    offLeash: 'Sans laisse autorisé',
    onLeash: 'En laisse uniquement',
    mixedZones: 'Zones mixtes',
    safetyLayout: 'Sécurité et aménagement',
    fullyFenced: 'Entièrement clôturé',
    partiallyFenced: 'Partiellement clôturé',
    noFencing: 'Sans clôture',
    separateAreas: 'Zones séparées petit/grand',
    amenities: 'Équipements',
    waterFountain: 'Fontaine à eau',
    wasteBags: 'Distributeurs de sacs',
    benches: 'Bancs',
    shade: 'Ombre',
    parking: 'Parking',
    agilityEquipment: "Équipement d'agilité",
    environment: 'Environnement',
    grass: 'Herbe',
    dirt: 'Terre',
    artificialTurf: 'Gazon synthétique',
    flatTerrain: 'Terrain plat',
    hillyTerrain: 'Terrain vallonné',
    quiet: 'Calme',
    crowded: 'Bondé',
    selectPet: 'Sélectionner un animal',
    noPets: 'Aucun animal ajouté',
    addPet: 'Ajouter un animal',
    distance: 'Distance',
    rating: 'Note',
    reviews: 'Avis',
    openNow: 'Ouvert maintenant',
    closed: 'Fermé',
    hours: 'Horaires',
    address: 'Adresse',
    directions: "Comment s'y rendre",
    rulesRegulations: 'Règles et règlements',
    safetyInfo: 'Informations de sécurité',
    knownHazards: 'Dangers connus',
    recentAlerts: 'Alertes récentes',
    writeReview: 'Écrire un avis',
    sortBy: 'Trier par',
    newest: 'Plus récent',
    mostHelpful: 'Plus utile',
    highestRated: 'Mieux noté',
    lowestRated: 'Moins bien noté',
    uploadPhotos: 'Téléverser des photos',
    submitReview: "Envoyer l'avis",
    helpful: 'Utile',
    report: 'Signaler',
    nearbyUsers: "Propriétaires d'animaux à proximité",
    organizeMeetup: 'Organiser une rencontre',
    findWalkingBuddy: 'Trouver un compagnon de promenade',
    offlineMode: 'Mode hors ligne',
    downloadMap: 'Télécharger pour hors ligne',
    downloaded: 'Téléchargé',
    totalParks: 'Total parcs',
    avgRating: 'Note moy.',
    nearby: 'À proximité',
    parkFound: 'parc trouvé',
    parksFound: 'parcs trouvés',
    parksCount: 'parcs',
    googleMapsNotConfigured: 'Google Maps non configuré',
    googleMapsNotConfiguredDescription:
      'Définissez PUBLIC_GOOGLE_MAPS_API_KEY dans petso/.env pour activer la carte.',
    failedToLoadGoogleMaps: 'Échec du chargement de Google Maps',
    failedToLoadGoogleMapsDescription:
      "Vérifiez votre clé API et que l'API Maps JavaScript et Places sont activées.",
    loadingMap: 'Chargement de la carte…',
    walkingBuddy: 'Companion de promenade',
    findCompatiblePartners: 'Trouver des compagnons de promenade compatibles',
    editWalkingBuddyPreferences:
      'Modifier les préférences du compagnon de promenade',
    walkingBuddySetup: 'Configuration du compagnon de promenade',
    updateAvailabilityPreferredTime:
      'Mettez à jour votre disponibilité et heure préférée',
    findCompatiblePartnersInArea:
      'Trouvez des compagnons de promenade compatibles dans votre zone',
    whenAvailable: 'Quand êtes-vous généralement disponible ?',
    preferredTimeOfDay: 'Moment de la journée préféré',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir',
    flexible: 'Flexible',
    privacy: 'Confidentialité',
    privacyNoticeWalkingBuddy:
      'Seuls les utilisateurs ayant aussi activé Compagnon de promenade peuvent voir votre profil. Vous pouvez le désactiver à tout moment.',
    savePreferences: 'Enregistrer les préférences',
    activateFindMatches: 'Activer et trouver des correspondances',
    saving: 'Enregistrement…',
    noMatchesYet: 'Pas encore de correspondances',
    checkBackLaterForMatches:
      'Revenez plus tard pour des compagnons de promenade compatibles',
    matchLabel: 'Correspondance',
    kmAway: 'km',
    parkInCommon: 'parc en commun',
    parksInCommon: 'parcs en commun',
    chat: 'Discussion',
    editPreferences: 'Modifier les préférences',
    energy: 'Énergie',
    close: 'Fermer',
    walkingBuddyActive: 'Companion de promenade actif',
    walkingBuddyDeactivated: 'Companion de promenade désactivé',
    failedToActivateWalkingBuddy:
      "Échec de l'activation du Compagnon de promenade",
    failedToLoadMatches: 'Échec du chargement des correspondances',
    failedToSaveChanges: "Échec de l'enregistrement des modifications",
    noParksNearby: 'Aucun parc à proximité',
    tryAdjustingFilters:
      "Essayez d'ajuster vos filtres ou la zone de recherche",
    noReviews: "Pas encore d'avis",
    beFirst: 'Soyez le premier à noter ce parc !',
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    share: 'Partager',
    favorite: 'Favori',
    small: 'Petit',
    medium: 'Moyen',
    large: 'Grand',
    lowEnergy: 'Faible énergie',
    mediumEnergy: 'Énergie moyenne',
    highEnergy: 'Haute énergie',
    shy: 'Timide',
    social: 'Sociable',
    reactive: 'Réactif',
    puppy: 'Chiot',
    senior: 'Senior',
    anxious: 'Anxieux',
  },
  de: {
    appName: 'Petso',
    findParks: 'Parks finden',
    myProfile: 'Mein Profil',
    settings: 'Einstellungen',
    mapView: 'Karte',
    listView: 'Liste',
    searchParks: 'Parks suchen...',
    filters: 'Filter',
    clearFilters: 'Alle löschen',
    applyFilters: 'Filter anwenden',
    accessRules: 'Zugangsregeln',
    offLeash: 'Ohne Leine erlaubt',
    onLeash: 'Nur mit Leine',
    mixedZones: 'Gemischte Zonen',
    safetyLayout: 'Sicherheit & Anlage',
    fullyFenced: 'Vollständig eingezäunt',
    partiallyFenced: 'Teilweise eingezäunt',
    noFencing: 'Kein Zaun',
    separateAreas: 'Getrennte Bereiche Klein/Groß',
    amenities: 'Ausstattung',
    waterFountain: 'Wasserstelle',
    wasteBags: 'Kotbeutelspender',
    benches: 'Bänke',
    shade: 'Schatten',
    parking: 'Parkplatz',
    agilityEquipment: 'Agility-Geräte',
    environment: 'Umgebung',
    grass: 'Rasen',
    dirt: 'Erde',
    artificialTurf: 'Kunstrasen',
    flatTerrain: 'Flaches Gelände',
    hillyTerrain: 'Hügeliges Gelände',
    quiet: 'Ruhig',
    crowded: 'Voll',
    selectPet: 'Tier auswählen',
    noPets: 'Noch keine Tiere hinzugefügt',
    addPet: 'Tier hinzufügen',
    distance: 'Entfernung',
    rating: 'Bewertung',
    reviews: 'Bewertungen',
    openNow: 'Jetzt geöffnet',
    closed: 'Geschlossen',
    hours: 'Öffnungszeiten',
    address: 'Adresse',
    directions: 'Route',
    rulesRegulations: 'Regeln & Vorschriften',
    safetyInfo: 'Sicherheitsinformationen',
    knownHazards: 'Bekannte Gefahren',
    recentAlerts: 'Aktuelle Hinweise',
    writeReview: 'Bewertung schreiben',
    sortBy: 'Sortieren nach',
    newest: 'Neueste',
    mostHelpful: 'Hilfreichste',
    highestRated: 'Bestbewertet',
    lowestRated: 'Schlechtestbewertet',
    uploadPhotos: 'Fotos hochladen',
    submitReview: 'Bewertung senden',
    helpful: 'Hilfreich',
    report: 'Melden',
    nearbyUsers: 'Tierbesitzer in der Nähe',
    organizeMeetup: 'Treffen organisieren',
    findWalkingBuddy: 'Gassigeher finden',
    offlineMode: 'Offline-Modus',
    downloadMap: 'Für Offline herunterladen',
    downloaded: 'Heruntergeladen',
    totalParks: 'Parks gesamt',
    avgRating: 'Durchschn. Bewertung',
    nearby: 'In der Nähe',
    parkFound: 'Park gefunden',
    parksFound: 'Parks gefunden',
    parksCount: 'Parks',
    googleMapsNotConfigured: 'Google Maps nicht konfiguriert',
    googleMapsNotConfiguredDescription:
      'PUBLIC_GOOGLE_MAPS_API_KEY in petso/.env setzen, um die Karte zu aktivieren.',
    failedToLoadGoogleMaps: 'Google Maps konnte nicht geladen werden',
    failedToLoadGoogleMapsDescription:
      'API-Schlüssel prüfen und Maps JavaScript API sowie Places API aktivieren.',
    loadingMap: 'Karte wird geladen…',
    walkingBuddy: 'Gassigeher',
    findCompatiblePartners: 'Kompatible Gassipartner finden',
    editWalkingBuddyPreferences: 'Gassigeher-Einstellungen bearbeiten',
    walkingBuddySetup: 'Gassigeher einrichten',
    updateAvailabilityPreferredTime:
      'Verfügbarkeit und bevorzugte Zeit anpassen',
    findCompatiblePartnersInArea:
      'Kompatible Gassipartner in Ihrer Nähe finden',
    whenAvailable: 'Wann sind Sie normalerweise verfügbar?',
    preferredTimeOfDay: 'Bevorzugte Tageszeit',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    flexible: 'Flexibel',
    privacy: 'Datenschutz',
    privacyNoticeWalkingBuddy:
      'Nur Nutzer mit aktiviertem Gassigeher können Ihr Profil sehen. Sie können jederzeit deaktivieren.',
    savePreferences: 'Einstellungen speichern',
    activateFindMatches: 'Aktivieren & Partner finden',
    saving: 'Wird gespeichert…',
    noMatchesYet: 'Noch keine Partner',
    checkBackLaterForMatches: 'Später nach kompatiblen Gassipartnern schauen',
    matchLabel: 'Partner',
    kmAway: 'km entfernt',
    parkInCommon: 'gemeinsamer Park',
    parksInCommon: 'gemeinsame Parks',
    chat: 'Chat',
    editPreferences: 'Einstellungen bearbeiten',
    energy: 'Energie',
    close: 'Schließen',
    walkingBuddyActive: 'Gassigeher ist aktiv',
    walkingBuddyDeactivated: 'Gassigeher deaktiviert',
    failedToActivateWalkingBuddy: 'Gassigeher konnte nicht aktiviert werden',
    failedToLoadMatches: 'Partner konnten nicht geladen werden',
    failedToSaveChanges: 'Änderungen konnten nicht gespeichert werden',
    noParksNearby: 'Keine Parks in der Nähe',
    tryAdjustingFilters: 'Filter oder Suchbereich anpassen',
    noReviews: 'Noch keine Bewertungen',
    beFirst: 'Seien Sie der Erste, der diesen Park bewertet!',
    save: 'Speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    share: 'Teilen',
    favorite: 'Favorit',
    small: 'Klein',
    medium: 'Mittel',
    large: 'Groß',
    lowEnergy: 'Wenig Energie',
    mediumEnergy: 'Mittlere Energie',
    highEnergy: 'Hohe Energie',
    shy: 'Schüchtern',
    social: 'Sozial',
    reactive: 'Reaktiv',
    puppy: 'Welpe',
    senior: 'Senior',
    anxious: 'Ängstlich',
  },
};

export const translations = {
  ...baseTranslations,
  it: {
    ...baseTranslations.en,
    findParks: 'Trova parchi',
    myProfile: 'Il mio profilo',
    settings: 'Impostazioni',
    mapView: 'Mappa',
    listView: 'Elenco',
    searchParks: 'Cerca parchi...',
    filters: 'Filtri',
    clearFilters: 'Cancella tutto',
    applyFilters: 'Applica filtri',
    accessRules: 'Regole di accesso',
    offLeash: 'Senza guinzaglio consentito',
    onLeash: 'Solo al guinzaglio',
    mixedZones: 'Zone miste',
    safetyLayout: 'Sicurezza e disposizione',
    fullyFenced: 'Completamente recintato',
    partiallyFenced: 'Parzialmente recintato',
    noFencing: 'Senza recinzione',
    separateAreas: 'Aree separate piccoli/grandi',
    amenities: 'Servizi',
    waterFountain: 'Fontanella',
    wasteBags: 'Distributori sacchetti',
    benches: 'Panchine',
    shade: 'Ombra',
    parking: 'Parcheggio',
    agilityEquipment: 'Attrezzatura agility',
    environment: 'Ambiente',
    grass: 'Erba',
    dirt: 'Terra',
    artificialTurf: 'Erba sintetica',
    flatTerrain: 'Terreno pianeggiante',
    hillyTerrain: 'Terreno collinare',
    quiet: 'Tranquillo',
    crowded: 'Affollato',
    selectPet: 'Seleziona animale',
    noPets: 'Nessun animale aggiunto',
    addPet: 'Aggiungi animale',
    distance: 'Distanza',
    rating: 'Valutazione',
    reviews: 'Recensioni',
    openNow: 'Aperto ora',
    closed: 'Chiuso',
    hours: 'Orari',
    address: 'Indirizzo',
    directions: 'Indicazioni',
    rulesRegulations: 'Regole e regolamenti',
    knownHazards: 'Rischi noti',
    recentAlerts: 'Avvisi recenti',
    writeReview: 'Scrivi una recensione',
    submitReview: 'Invia recensione',
    nearbyUsers: 'Proprietari di animali nelle vicinanze',
    organizeMeetup: 'Organizza un incontro',
    findWalkingBuddy: 'Trova un compagno di passeggiata',
    totalParks: 'Parchi totali',
    avgRating: 'Valutazione media',
    nearby: 'Nelle vicinanze',
    parkFound: 'parco trovato',
    parksFound: 'parchi trovati',
    parksCount: 'parchi',
    googleMapsNotConfigured: 'Google Maps non configurato',
    googleMapsNotConfiguredDescription:
      'Imposta PUBLIC_GOOGLE_MAPS_API_KEY in petso/.env per abilitare la mappa.',
    failedToLoadGoogleMaps: 'Impossibile caricare Google Maps',
    failedToLoadGoogleMapsDescription:
      'Controlla la chiave API e che Maps JavaScript API + Places API siano abilitate.',
    loadingMap: 'Caricamento mappa…',
    walkingBuddy: 'Compagno di passeggiata',
    findCompatiblePartners: 'Trova compagni di passeggiata compatibili',
    editWalkingBuddyPreferences: 'Modifica preferenze compagno di passeggiata',
    walkingBuddySetup: 'Configurazione compagno di passeggiata',
    updateAvailabilityPreferredTime:
      'Aggiorna disponibilità e fascia oraria preferita',
    findCompatiblePartnersInArea:
      'Trova compagni di passeggiata compatibili nella tua zona',
    whenAvailable: 'Quando sei solitamente disponibile?',
    preferredTimeOfDay: 'Fascia oraria preferita',
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    morning: 'Mattina',
    afternoon: 'Pomeriggio',
    evening: 'Sera',
    flexible: 'Flessibile',
    privacy: 'Privacy',
    privacyNoticeWalkingBuddy:
      'Solo gli utenti con Compagno di passeggiata attivo possono vedere il tuo profilo. Puoi disattivarlo in qualsiasi momento.',
    savePreferences: 'Salva preferenze',
    activateFindMatches: 'Attiva e trova abbinamenti',
    saving: 'Salvataggio…',
    noMatchesYet: 'Nessun abbinamento ancora',
    checkBackLaterForMatches:
      'Torna più tardi per trovare compagni di passeggiata compatibili',
    matchLabel: 'Compatibilità',
    kmAway: 'km di distanza',
    parkInCommon: 'parco in comune',
    parksInCommon: 'parchi in comune',
    chat: 'Chat',
    editPreferences: 'Modifica preferenze',
    energy: 'Energia',
    walkingBuddyActive: 'Compagno di passeggiata attivo',
    walkingBuddyDeactivated: 'Compagno di passeggiata disattivato',
    failedToActivateWalkingBuddy:
      'Impossibile attivare Compagno di passeggiata',
    failedToLoadMatches: 'Impossibile caricare gli abbinamenti',
    failedToSaveChanges: 'Impossibile salvare le modifiche',
    noParksNearby: 'Nessun parco trovato nelle vicinanze',
    tryAdjustingFilters: 'Prova a modificare i filtri o l’area di ricerca',
    noReviews: 'Nessuna recensione ancora',
    beFirst: 'Sii il primo a recensire questo parco!',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    lowEnergy: 'Bassa energia',
    mediumEnergy: 'Energia media',
    highEnergy: 'Alta energia',
    shy: 'Timido',
    social: 'Socievole',
    reactive: 'Reattivo',
    puppy: 'Cucciolo',
    senior: 'Senior',
    anxious: 'Ansioso',
    save: 'Salva',
    cancel: 'Annulla',
    edit: 'Modifica',
    delete: 'Elimina',
    share: 'Condividi',
    favorite: 'Preferito',
    close: 'Chiudi',
    surface: 'Superficie',
    terrain: 'Terreno',
    crowdLevel: 'Affluenza',
    about: 'Informazioni',
    overview: 'Panoramica',
    meetups: 'Incontri',
    organize: 'Organizza',
    upcomingMeetups: 'Prossimi incontri',
    noUpcomingMeetups: 'Nessun incontro in programma',
    beFirstOrganizeMeetup:
      'Sii il primo a organizzare un incontro in questo parco!',
    createMeetup: 'Crea incontro',
    writeFirstReview: 'Scrivi la prima recensione',
    verifiedBadge: 'Verificato',
    addPhotos: 'Aggiungi foto',
    shareToSocial: 'Condividi sui social',
    helpfulMarked: 'Segnato come utile',
    voteRemoved: 'Voto rimosso',
    failedToUpdateVote: 'Impossibile aggiornare il voto',
    linkCopiedToClipboard: 'Link copiato negli appunti!',
    shareParkText: 'Guarda {{parkName}} su Petso!',
    filterParksDescription: 'Filtra i parchi in base a vari criteri',
    parkDetails: 'Dettagli parco',
    parkDetailsDescription: 'Informazioni dettagliate sul parco selezionato',
    yourLocation: 'La tua posizione',
    centerOnCurrentLocation: 'Centra sulla posizione attuale',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    openingSocialToChat: 'Apertura Social per la chat...',
    failedToStartChat: 'Impossibile avviare la chat',
    meetupFull: 'Questo incontro è al completo',
    rsvpGoing: 'Parteciperai!',
    rsvpMaybe: 'Segnato come forse',
    rsvpCancelled: 'RSVP annullato',
    failedToUpdateRSVP: "Impossibile aggiornare l'RSVP",
    going: 'partecipanti',
    spotLeftSingular: 'posto rimasto',
    spotsLeftPlural: 'posti rimasti',
    full: 'Completo',
    organizedBy: 'Organizzato da',
    cancelRSVP: 'Annulla RSVP',
    imGoing: 'Partecipo',
    maybe: 'Forse',
    minutesShort: 'min',
    dateRequired: 'Data *',
    timeRequired: 'Ora *',
    meetupEnterTitle: 'Inserisci un titolo',
    meetupSelectDateTime: 'Seleziona data e ora',
    meetupTimeFuture: "L'orario dell'incontro deve essere nel futuro",
    meetupDurationRange: 'La durata deve essere tra 30 e 480 minuti',
    meetupParticipantsRange: 'I partecipanti devono essere tra 2 e 50',
    meetupCreatedSuccess: 'Incontro creato con successo!',
    meetupCreateFailed: "Impossibile creare l'incontro. Riprova.",
    createMeetupAtPark:
      'Crea un incontro a {{parkName}} e connettiti con altri proprietari di animali',
    meetupTitleRequired: 'Titolo incontro *',
    meetupTitlePlaceholder: 'es. Passeggiata e gioco del mattino',
    description: 'Descrizione',
    meetupDescriptionPlaceholder: "Condividi i dettagli dell'incontro...",
    meetupDurationMinutes: 'Durata (minuti)',
    meetupDurationHint: '30-480 minuti',
    meetupMaxParticipants: 'Partecipanti massimi',
    meetupParticipantsHint: '2-50 persone',
    meetupOrganizerTipsTitle: "Suggerimenti per l'organizzatore:",
    meetupOrganizerTipsBody:
      'Incontra in una zona visibile, condividi i contatti con i partecipanti e assicurati che i cani siano al guinzaglio o nelle aree senza guinzaglio consentite.',
    creating: 'Creazione...',
    ratingRequired: 'Valutazione *',
    reviewSelectRating: 'Seleziona una valutazione',
    reviewMinCharacters:
      'La recensione deve contenere almeno {{count}} caratteri',
    reviewMaxCharacters:
      'La recensione deve contenere meno di {{count}} caratteri',
    reviewSubmittedSuccess: 'Recensione inviata con successo!',
    reviewSubmitFailed: 'Impossibile inviare la recensione. Riprova.',
    shareExperienceAtPark: 'Condividi la tua esperienza a {{parkName}}',
    starSingular: 'stella',
    starPlural: 'stelle',
    titleOptional: 'Titolo (opzionale)',
    reviewTitlePlaceholder: 'es. Ottimo parco per cani piccoli!',
    yourReviewRequired: 'La tua recensione *',
    reviewContentPlaceholder: 'Condividi i dettagli della tua esperienza...',
    reviewMinimumCharacters: 'Minimo {{count}} caratteri',
    visitDateOptional: 'Data della visita (opzionale)',
    tagsOptional: 'Tag (opzionale)',
    reviewingWith: 'Recensione con:',
    submitting: 'Invio...',
    reviewTagClean: 'Pulito',
    reviewTagSafe: 'Sicuro',
    reviewTagBusy: 'Affollato',
    reviewTagQuiet: 'Tranquillo',
    reviewTagShady: 'Ombreggiato',
    reviewTagWellMaintained: 'Ben tenuto',
    reviewTagSpacious: 'Spazioso',
    reviewTagFriendlyDogs: 'Cani socievoli',
    photoInvalidType: 'Tipo file non valido. Usa JPG, PNG o WebP.',
    photoTooLarge: 'File troppo grande. Dimensione massima 5MB.',
    photoMaxAllowed: 'Massimo {{count}} foto consentite.',
    photoSelectAtLeastOne: 'Seleziona almeno una foto',
    photoUploadedPendingModeration:
      '{{count}} foto{{suffix}} caricate! In attesa di moderazione.',
    photoUploadFailed: 'Impossibile caricare le foto. Riprova.',
    photosUploaded: 'Foto caricate',
    photosUploadedDescription:
      'Le tue foto da {{parkName}} sono caricate e in attesa di moderazione. Condividere su Petso Social?',
    photosUploadDescription:
      'Condividi foto di {{parkName}}. Le foto saranno revisionate prima di apparire nella galleria.',
    alsoShareToSocial: 'Condividere anche sui social?',
    alsoShareToSocialDescription:
      'Pubblica su Petso Social con posizione impostata su {{parkName}}. Puoi aggiungere didascalia e taggare animali.',
    done: 'Fatto',
    photoDropOrBrowse: 'Trascina qui le foto o clicca per sfogliare',
    photoFormatsHint: 'JPG, PNG o WebP • Max 5MB • Fino a {{count}} foto',
    photosCount: 'Foto ({{current}}/{{max}})',
    maximumReached: 'Massimo raggiunto',
    photoPreviewAlt: 'Anteprima',
    photoCaptionOptional: 'Aggiungi una didascalia (opzionale)',
    moderationNotice: 'Avviso moderazione',
    moderationNoticeDescription:
      'Le foto saranno controllate prima della pubblicazione. Questo aiuta a mantenere qualità e sicurezza della community.',
    uploading: 'Caricamento...',
    uploadAction: 'Carica{{count}}',
    reportSubmittedSuccess:
      'Segnalazione inviata. Grazie per contribuire alla sicurezza della community.',
    reportSubmitFailed: 'Impossibile inviare la segnalazione. Riprova.',
    reportTypeReview: 'recensione',
    reportTypePhoto: 'foto',
    reportTypeMessage: 'messaggio',
    reportContentLabel: 'Segnala {{type}}',
    reportContentDescription:
      'Aiutaci a mantenere Petso sicuro segnalando contenuti inappropriati',
    reporting: 'Stai segnalando:',
    reasonForReportingRequired: 'Motivo della segnalazione *',
    reportReasonSpam: 'Spam o pubblicità',
    reportReasonInappropriate: 'Contenuto inappropriato',
    reportReasonHarassment: 'Molestie o bullismo',
    reportReasonMisinformation: 'Informazioni false o fuorvianti',
    reportReasonOffensive: 'Linguaggio o immagini offensive',
    reportReasonOther: 'Altro (specifica)',
    additionalDetails: 'Dettagli aggiuntivi',
    optional: 'opzionale',
    reportContextPlaceholder: 'Fornisci maggior contesto...',
    reportPrivacyNotice:
      'Le segnalazioni vengono revisionate dal nostro team di moderazione. La tua segnalazione è anonima per il creatore del contenuto.',
    submitReport: 'Invia segnalazione',
    weatherCurrent: 'Meteo attuale',
    weatherUpdated: 'Aggiornato',
    humidity: 'Umidità',
    wind: 'Vento',
    weatherExcellent: '🌟 Eccellente per passeggiare',
    weatherGood: '👍 Buono per passeggiare',
    weatherFair: '😐 Condizioni discrete',
    weatherPoor: '⚠️ Condizioni sfavorevoli',
    weatherUnknown: 'Sconosciuto',
  },
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
